import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { deleteFile } from '@widgets/Files/api/deleteFile';
import { handleStatusError } from '@widgets/Files/helpers/handleStatusError';

export const useDeleteFile = () => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation({
        mutationKey: ['deleteFile'],
        mutationFn: deleteFile,
        onSuccess: (data) => {
            handleStatusError(data, t('useFileUpload.return.swal.manyFiles.button'));
            if (data.status === 'success') {
                queryClient.invalidateQueries({ queryKey: ['files'] });
            }
        },
    });
};
